/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityhumorstylenorth3Inputs */



/**
* | output |
* | --- |
* | "Commentator" |
*
* @param {Personalityhumorstylenorth3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityhumorstylenorth3 = /** @type {((inputs?: Personalityhumorstylenorth3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityhumorstylenorth3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Commentator")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comentarista")
	return /** @type {LocalizedString} */ ("Комментатор")
});
export { personalityhumorstylenorth3 as "personalityHumorStyleNorth" }